import { Stack } from 'component-library';

import { SectionHeader } from './Section';

export const OnboardingIntroduction = () => {
  return (
    <Stack spacing={12}>
      <SectionHeader i18nPath='shared.onboarding.introduction.descriptionPartOne' />
      <SectionHeader i18nPath='shared.onboarding.introduction.descriptionPartTwo' />
    </Stack>
  );
};
